export default __webpack_public_path__ + "static/media/grafema_ummi_09.563af4d5.jpg";